import { Enum, EnumType } from 'ts-jenum';
import { IGridFilterItem } from '../filters/IGridFilterItem';

@Enum<CallHistoryFilterType>('value')
export class CallHistoryFilterType extends EnumType<CallHistoryFilterType>() implements IGridFilterItem {
   static readonly INBOUND = new CallHistoryFilterType('INBOUND', 'samwin.types.call_history_filters.inbound');
   static readonly OUTBOUND = new CallHistoryFilterType('OUTBOUND', 'samwin.types.call_history_filters.outbound');
   static readonly INTERNAL = new CallHistoryFilterType('INTERNAL', 'samwin.types.call_history_filters.internal');
   static readonly EXTERNAL = new CallHistoryFilterType('EXTERNAL', 'samwin.types.call_history_filters.external');
   static readonly MISSED_OR_NO_ANSWER = new CallHistoryFilterType('MISSED_OR_NO_ANSWER', 'samwin.types.call_history_filters.missed_or_no_answer');
   static readonly TRANSFERRED = new CallHistoryFilterType('TRANSFERRED', 'samwin.types.call_history_filters.transferred');
   static readonly DECLINED = new CallHistoryFilterType('DECLINED', 'samwin.types.call_history_filters.declined');
   static readonly TODO = new CallHistoryFilterType('TODO', 'samwin.types.call_history_filters.todo');
   static readonly IN_PROGRESS = new CallHistoryFilterType('IN_PROGRESS', 'samwin.types.call_history_filters.in_progress');
   static readonly DONE = new CallHistoryFilterType('DONE', 'samwin.types.call_history_filters.done');
   static readonly ONLY_ACTIVE_SKILLS = new CallHistoryFilterType('ONLY_ACTIVE_SKILLS', 'samwin.types.call_history_filters.only_active_skills');
   static readonly ONLY_MY_CALLS = new CallHistoryFilterType('ONLY_MY_CALLS', 'samwin.types.call_history_filters.only_my_calls');
   static readonly ONLY_NEWEST_CALLS_PER_PEER_ID = new CallHistoryFilterType(
      'ONLY_NEWEST_CALLS_PER_PEER_ID',
      'samwin.types.call_history_filters.only_newest_calls_per_peer_id'
   );
   static readonly ONLY_MY_CHATS = new CallHistoryFilterType('ONLY_MY_CHATS', 'samwin.types.call_history_filters.only_my_chats');
   static readonly ONLY_MY_CONVERSATIONS = new CallHistoryFilterType('ONLY_MY_CONVERSATIONS', 'samwin.types.call_history_filters.only_my_conversations');

   private constructor(public value: string, public translationKey: string) {
      super();
   }

   public get filterKey(): string {
      return this.value;
   }
}
